var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Resumable from 'resumablejs';
import { store } from '../../store';
const useResumableFilesUpload = ({ allowedFileTypes, maxFileSize, files, }) => {
    _react_refresh_temp_1();
    const toastId = React.useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    const [result, setResult] = useState();
    const { t } = useTranslation();
    const session = store.getState().session;
    useEffect(() => {
        if (files && files.length) {
            sendFile(files);
        }
    }, [files]);
    const sendFile = (files) => {
        var _a;
        let fileName = '';
        const r = new Resumable({
            target: window.PLUG_N_MEET_SERVER_URL + '/api/fileUpload',
            uploadMethod: 'POST',
            query: {
                sid: session.currentRoom.sid,
                roomId: session.currentRoom.room_id,
                userId: (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.userId,
                resumable: true,
            },
            headers: {
                Authorization: session.token,
            },
            fileType: allowedFileTypes,
            fileTypeErrorCallback(file) {
                toast(t('notifications.file-type-not-allow', { filetype: file.type }), {
                    type: 'error',
                });
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            maxFileSize: maxFileSize ? Number(maxFileSize) * 1000000 : undefined,
            maxFileSizeErrorCallback() {
                toast(t('notifications.max-file-size-exceeds'), {
                    type: 'error',
                });
            },
        });
        r.on('fileAdded', function (file) {
            fileName = file.fileName;
            if (!r.isUploading()) {
                setIsUploading(true);
                r.upload();
            }
        });
        r.on('fileSuccess', function (file, message) {
            const res = JSON.parse(message);
            setIsUploading(false);
            setTimeout(() => {
                var _a;
                toast.dismiss((_a = toastId.current) !== null && _a !== void 0 ? _a : '');
            }, 300);
            if (res.status) {
                setResult({
                    filePath: res.filePath,
                    fileName: res.fileName,
                    fileExtension: res.fileExtension,
                });
            }
        });
        r.on('fileError', function (file, message) {
            setIsUploading(false);
            setTimeout(() => {
                var _a;
                toast.dismiss((_a = toastId.current) !== null && _a !== void 0 ? _a : '');
            }, 300);
            try {
                const res = JSON.parse(message);
                toast(t(res.msg), {
                    type: 'error',
                });
            }
            catch (e) {
                toast(t('right-panel.file-upload-default-error'), {
                    type: 'error',
                });
            }
        });
        r.on('uploadStart', function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            toastId.current = toast(t('right-panel.uploading-file', {
                fileName,
            }), {
                closeButton: false,
                progress: 0,
            });
        });
        r.on('fileProgress', function (file) {
            var _a;
            const progress = file.progress(false);
            toast.update((_a = toastId.current) !== null && _a !== void 0 ? _a : '', {
                progress: Number(progress),
            });
        });
        r.addFiles(files);
    };
    return {
        isUploading,
        result,
    };
};
_react_refresh_temp_1(useResumableFilesUpload, "Ac6eeQ8CfGNym2MpZNneKzdHnME=", false, () => [useTranslation]);
export default useResumableFilesUpload;
